export const colors = [
  { name: "grey", code: "#938767" },
  { name: "clay", code: "#BC8431" },
  { name: "brown", code: "#A06730" },
  { name: "coral", code: "#C16038" },
  { name: "rose", code: "#D05A5A" },
  { name: "pink", code: "#FF4D6E" },
  { name: "lime", code: "#AAB200" },
  { name: "gold", code: "#D1A609" },
  { name: "yellow", code: "#E3CD00" },
  { name: "orange", code: "#FF9211" },
  { name: "pumpkin", code: "#FF7C1E" },
  { name: "red", code: "#FF563F" },
  { name: "grass", code: "#7DA925" },
  { name: "chartruse", code: "#90A74E" },
  { name: "green", code: "#22A749" },
  { name: "forest", code: "#47AE90" },
  { name: "aqua", code: "#49A6A6" },
  { name: "blue", code: "#3D98F4" },
  { name: "magenta", code: "#FF60C9" },
  { name: "lilac", code: "#CC5DAB" },
  { name: "purple", code: "#B07ED7" },
  { name: "lavendar", code: "#977EB6" },
  { name: "orcchid", code: "#817BCA" },
  { name: "cloud", code: "#6796CD" },
];
